import Button from "../../../../../src/components/button/Button";
import { Playground, Props } from 'docz';
import * as React from 'react';
export default {
  Button,
  Playground,
  Props,
  React
};